import React from 'react';

// eslint-disable-next-line no-console
export const defaultNotify = ({ message, type, timeout = 3000 }) => { console.log(message, type); };
const NotificationsContext = React.createContext(defaultNotify);
export const { Provider, Consumer } = NotificationsContext;
export const useNotify = () => React.useContext(NotificationsContext);
export default NotificationsContext;
